import { useState } from 'react';
import { SEOHead, getBreadcrumbSchema } from './SEO';

const GALLERY_IMAGES = [
  { src: "https://customer-assets.emergentagent.com/job_ea5ac245-dc0b-4af5-84d2-a4f9511a03e3/artifacts/xtgoxjvv_20251204_164049.jpg", title: "Accident Recovery - Truck Damage Assessment", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_ea5ac245-dc0b-4af5-84d2-a4f9511a03e3/artifacts/1993zc3d_20251204_162703.jpg", title: "Flatbed Towing - Accident Vehicle Transport", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_ea5ac245-dc0b-4af5-84d2-a4f9511a03e3/artifacts/y9md666p_20251204_125402.jpg", title: "Secured Vehicle on Flatbed - Professional Recovery", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/8q0iuh6e_20250807_095508.jpg", title: "Heavy Equipment & Boat Hauling", cat: "hauling" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/wrobg7xg_20250625_102142.jpg", title: "Van Transport Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/7t1492w1_20250615_185122.jpg", title: "Boat & Trailer Transport", cat: "hauling" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/l22s5b0x_20250321_120217.jpg", title: "Commercial Dump Truck Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/3hgjwp4o_20250130_102742.jpg", title: "Classic Porsche Transport", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/bxnuxxqa_20230406_125127.jpg", title: "Classic Car Transport", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/7q3fbz9o_20221016_183256.jpg", title: "Sports Car Flatbed Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/izmq4e40_20220512_084811.jpg", title: "Professional Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/kfycsq3e_20220522_160139.jpg", title: "Luxury Vehicle Transport", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/amv53wgg_20210817_115915.jpg", title: "Sheriff Vehicle Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/jz65ndb0_20210816_151947.jpg", title: "High-End Vehicle Towing", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/ypcqbfgx_20210811_130910.jpg", title: "Flatbed in Action", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/tokem4r0_20210811_130914.jpg", title: "Vehicle Recovery Service", cat: "towing" },
  { src: "https://customer-assets.emergentagent.com/job_a2b-towing/artifacts/vhek8nna_6679%20Transparent.jpg", title: "Custom Tow Truck", cat: "towing" },
];

const FILTERS = ['All', 'Towing', 'Hauling'];

function GalleryPage() {
  const [filter, setFilter] = useState('All');
  const filtered = filter === 'All' ? GALLERY_IMAGES : GALLERY_IMAGES.filter(img => img.cat === filter.toLowerCase());

  return (
    <div className="min-h-screen bg-black pt-16" data-testid="gallery-page">
      <SEOHead
        title="Photo Gallery - A2B Towing Service Photos | Orangevale CA"
        description="View A2B Towing photos: flatbed trucks, classic car transport, luxury vehicle towing & roadside assistance in Orangevale, CA."
        canonical="/gallery"
        schema={getBreadcrumbSchema([{ name: "Home", path: "/" }, { name: "Gallery", path: "/gallery" }])}
      />

      <section className="pt-16 pb-12 bg-zinc-950">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-block mb-4 px-4 py-2 bg-red-600/10 border border-red-600/30 rounded-full">
            <span className="text-red-600 text-sm font-semibold">Photo Gallery</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-testid="gallery-heading">A2B Towing Photo Gallery</h1>
          <p className="text-gray-400 text-lg mb-8">Take a look at our professional towing and roadside assistance services.</p>
          <div className="flex gap-3 justify-center">
            {FILTERS.map(f => (
              <button key={f} onClick={() => setFilter(f)} className={`px-4 py-2 rounded-md text-sm font-semibold transition-all ${filter === f ? 'bg-red-600 text-white' : 'bg-zinc-800 text-gray-400 hover:text-white'}`} data-testid={`filter-${f.toLowerCase()}`}>{f}</button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((img) => (
              <div key={img.src} className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden group" data-testid={`gallery-item-${img.title.replace(/\s+/g, '-').toLowerCase()}`}>
                <img src={img.src} alt={`A2B Towing - ${img.title}`} className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
                <div className="p-4">
                  <h3 className="text-white font-semibold">{img.title}</h3>
                  <span className="text-red-600 text-xs font-semibold uppercase">{img.cat}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default GalleryPage;
